import { MdModeEdit } from "react-icons/md";
import { colors } from "../../utils/colors";

export const AccountName = () => {
    return (
        <div className="account-name-section">
            <div className="account-name-contents">
                <h3>Adv Plus Bank - 1111</h3>

                <MdModeEdit color={colors.orange} size={30} className="edit-button" />

                <button className="banking-numbers">Account & Routing number</button>
            </div>
        </div>
    );
};
